import { parseISO, format } from 'date-fns';

const getDateFullMonthFullYear = (dateISOString: string) => {
  const parsedDate = parseISO(dateISOString);

  return format(parsedDate, 'd MMMM yyyy');
};

export default getDateFullMonthFullYear;
